import React, { useState } from "react";
import {
  Accordion,
  Row,
  Col,
  Form,
  Button,
  Stack,
  Modal,
} from "react-bootstrap";
import { toast } from "react-toastify";
import moment from "moment";
import { Link } from "react-router-dom";
import PropTypes from "prop-types";
import WorkOrderActiveWorkItemTransitions from "./WorkOrderActiveWorkItemTransitions";
import "./WorkOrderActiveWorkItem.css";
import WorkOrderWorkItemProgress from "./WorkOrderWorkItemProgress";
import { noScheduling, showProgress, contactable } from "./Templates";
import { useWorkOrderItems } from "../../data/WorkItemHook";
import SpinnerButton from "../shared/Spinnerbutton";

const dontShowRemakeButtonWhen = [
  "Office Referral",
  "Client Referral",
  "Awaiting Parts",
  "Arrange Further Visit Attempt 1",
  "Arrange Further Visit Attempt 2",
];

function WorkOrderActiveWorkItem({ workItem, mode, workOrder }) {
  const workItemsRepository = useWorkOrderItems();
  const [isSaving, setIsSaving] = useState(false);
  const [chosenItem, setChosenItem] = useState("");
  const handleContactSuccess = async () => {
    setIsSaving(true);
    try {
      await workItemsRepository.updateWorkItem({
        ...workItem,
        successful: "Yes",
      });
    } catch (err) {
      toast.error(
        "This has already been submitted, please give time for the DFR to be created and refresh the page."
      );
    }
    setIsSaving(false);
    setChosenItem("");
  };

  const workItemView = (
    <>
      <Row className="mb-2">
        <Col>
          <Row className="mb-4" style={{ display: "none" }}>
            <Col>
              <WorkOrderWorkItemProgress workItem={workItem} />
            </Col>
          </Row>
          <Row>
            <Col xs={6}>
              <Form.Label className="form-label-heading work-item-group-title">
                Work Item Details
              </Form.Label>
            </Col>
            {!noScheduling.includes(workItem.name) && (
              <Col xs={6}>
                <Form.Label className="form-label-heading work-item-group-title">
                  Scheduling
                </Form.Label>
              </Col>
            )}
          </Row>
          <Row>
            <Col className="workItem-group">
              <Row>
                <Col xs={3}>
                  <Form.Label className="form-label-heading">
                    Reference
                  </Form.Label>
                </Col>
                <Col>
                  <Form.Label>{workItem.reference}</Form.Label>
                </Col>
              </Row>
              <Row>
                <Col xs={3}>
                  <Form.Label className="form-label-heading">
                    Template
                  </Form.Label>
                </Col>
                <Col>
                  <Form.Label>{workItem.name}</Form.Label>
                </Col>
              </Row>
              <Row>
                <Col xs={3}>
                  <Form.Label className="form-label-heading">
                    Assigned To
                  </Form.Label>
                </Col>
                <Col>
                  <Form.Label>{workItem.assignedTo}</Form.Label>
                </Col>
              </Row>
              <Row>
                <Col xs={3}>
                  <Form.Label className="form-label-heading">
                    Work Item Category
                  </Form.Label>
                </Col>
                <Col>
                  <Form.Label>{workItem.wiCategory}</Form.Label>
                </Col>
              </Row>
              <Row>
                <Col xs={3}>
                  <Form.Label className="form-label-heading">
                    Issue Description
                  </Form.Label>
                </Col>
                <Col>
                  <Form.Label>{workItem.notes}</Form.Label>
                </Col>
              </Row>
              <Row>
                <Col xs={3}>
                  <Form.Label className="form-label-heading">
                    Work Item Notes
                  </Form.Label>
                </Col>
                <Col>
                  <Form.Label>{workItem.workItemNotes}</Form.Label>
                </Col>
              </Row>
              <Row>
                <Col xs={3}>
                  <Form.Label className="form-label-heading">
                    Assigned To
                  </Form.Label>
                </Col>
                <Col>
                  <Form.Label>{workItem.assignedTo}</Form.Label>
                </Col>
              </Row>
              <Row>
                <Col xs={3}>
                  <Form.Label className="form-label-heading">Status</Form.Label>
                </Col>
                <Col>
                  <Form.Label>{workItem.status}</Form.Label>
                </Col>
              </Row>
              {workItem.cancellationReason && (
                <Row>
                  <Col xs={3}>
                    <Form.Label className="form-label-heading">
                      Cancellation Reason
                    </Form.Label>
                  </Col>
                  <Col>
                    <Form.Label>{workItem.cancellationReason}</Form.Label>
                  </Col>
                </Row>
              )}
              {workItem.cancelledBy && (
                <Row>
                  <Col xs={3}>
                    <Form.Label className="form-label-heading">
                      Cancelled By
                    </Form.Label>
                  </Col>
                  <Col>
                    <Form.Label>{workItem.cancelledBy}</Form.Label>
                  </Col>
                </Row>
              )}
              <Row>
                <Col xs={3}>
                  <Form.Label className="form-label-heading">
                    Created Date
                  </Form.Label>
                </Col>
                <Col>
                  <Form.Label>
                    {workItem.createdOn
                      ? moment(workItem.createdOn).format("DD/MM/YYYY h:mm a")
                      : ""}
                  </Form.Label>
                </Col>
              </Row>

              {showProgress === workItem.name && (
                <>
                  <Row>
                    <Col xs={3}>
                      <Form.Label className="form-label-heading">
                        Progress Status
                      </Form.Label>
                    </Col>
                    <Col>
                      <Form.Label>{workItem.progressStatus}</Form.Label>
                    </Col>
                  </Row>
                  <Row>
                    <Col xs={3}>
                      <Form.Label className="form-label-heading">
                        Progress Notes
                      </Form.Label>
                    </Col>
                    <Col>
                      <Form.Label>{workItem.progressNotes}</Form.Label>
                    </Col>
                  </Row>
                </>
              )}
            </Col>
            {!noScheduling.includes(workItem.name) && (
              <Col className="workItem-group">
                <Row>
                  <Col xs={3}>
                    <Form.Label className="form-label-heading">
                      Scheduled Date
                    </Form.Label>
                  </Col>
                  <Col>
                    <Form.Label>
                      {workItem.scheduledDate &&
                        moment(workItem.scheduledDate).format(
                          "DD/MM/YYYY h:mm a"
                        )}
                    </Form.Label>
                  </Col>
                </Row>
                <Row>
                  <Col xs={3}>
                    <Form.Label className="form-label-heading">
                      Preferred Appointment Date
                    </Form.Label>
                  </Col>
                  <Col>
                    <Form.Label>
                      {workItem.preferredAppointmentDate &&
                        moment(workItem.preferredAppointmentDate).format(
                          "DD/MM/YYYY h:mm a"
                        )}
                    </Form.Label>
                  </Col>
                </Row>
                <Row>
                  <Col xs={3}>
                    <Form.Label className="form-label-heading">
                      Preferred Appointment Timeslot
                    </Form.Label>
                  </Col>
                  <Col>
                    <Form.Label>
                      {workItem.preferredAppointmentTimeslot}
                    </Form.Label>
                  </Col>
                </Row>
                <Row>
                  <Col xs={3}>
                    <Form.Label className="form-label-heading">
                      Work Item Agreement
                    </Form.Label>
                  </Col>
                  <Col>
                    <Form.Label>{workItem.workItemAgreement}</Form.Label>
                  </Col>
                </Row>
                <Row>
                  <Col xs={3}>
                    <Form.Label className="form-label-heading">
                      Job Specific Access Notes
                    </Form.Label>
                  </Col>
                  <Col>
                    <Form.Label>{workItem.jobSpecificAccessNotes}</Form.Label>
                  </Col>
                </Row>
              </Col>
            )}
          </Row>
          <Row className="mt-4">
            <Col>
              <Form.Label className="form-label-heading work-item-group-title">
                Transitions
              </Form.Label>
            </Col>
          </Row>
          <Row>
            <Col>
              <WorkOrderActiveWorkItemTransitions
                transitions={workItem.transitions}
              />
            </Col>
          </Row>
          {workItem.name === "Project - Property (Asset)" ? (
            <Row className="mt-4 active-work-item-options">
              <Col>
                <Link
                  className="update-work-item-link"
                  to={`/property/${workOrder.propertyId}/workorder/${workOrder.id}/workitem/${workItem.id}/update`}
                >
                  <Button>Update Work Item</Button>
                </Link>
              </Col>
            </Row>
          ) : (
            !dontShowRemakeButtonWhen.includes(
              workItem.workitemtemplatedisplayname
            ) && (
              <Row className="mt-4 active-work-item-options">
                <Col>
                  <Link
                    className="remake-work-item-link"
                    to={`/property/${workOrder.propertyId}/workorder/${workOrder.id}/workitem/${workItem.id}/remake`}
                  >
                    <Button>Remake</Button>
                  </Link>
                </Col>
              </Row>
            )
          )}
          {contactable.includes(workItem.name) && (
            <Row className="mt-4 active-work-item-options">
              <Col>
                <Button onClick={() => setChosenItem(workItem.id)}>
                  Contact Successful
                </Button>
              </Col>
            </Row>
          )}
        </Col>
      </Row>

      <Modal show={chosenItem === workItem.id} onHide={() => setChosenItem("")}>
        <Modal.Header closeButton>
          <Modal.Title>Contact Successful?</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Have you managed to make contact with the customer?
          <br />
          Submitting this will result in a new Domestic Field Reactive work item
          being created.
          <br />
          After submission,
          <span style={{ fontWeight: "bold" }}> please wait 30 seconds </span>
          and refresh the page for this to appear.
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={() => setChosenItem("")} variant="secondary">
            Cancel
          </Button>
          <SpinnerButton
            text="Submit"
            variant="primary"
            action={handleContactSuccess}
            waiting={isSaving}
          />
        </Modal.Footer>
      </Modal>
    </>
  );

  if (mode === "single") return workItemView;

  return (
    <Accordion.Item eventKey={workItem.id}>
      <Accordion.Header>
        <Stack gap={2}>
          <div>
            <b>Reference:</b> {workItem.reference}
          </div>
          <div>
            <b>Type:</b> {workItem.name}
          </div>
        </Stack>
      </Accordion.Header>
      <Accordion.Body>{workItemView}</Accordion.Body>
    </Accordion.Item>
  );
}

WorkOrderActiveWorkItem.propTypes = {
  mode: PropTypes.oneOf(["single", "multi"]).isRequired,
  workOrder: PropTypes.shape({
    id: PropTypes.string,
    propertyId: PropTypes.string,
  }).isRequired,
  workItem: PropTypes.shape({
    notes: PropTypes.string,
    assignedTo: PropTypes.string,
    status: PropTypes.string,
    cancellationReason: PropTypes.string,
    cancelledBy: PropTypes.string,
    progressStatus: PropTypes.string,
    progressNotes: PropTypes.string,
    scheduledDate: PropTypes.string,
    preferredAppointmentDate: PropTypes.string,
    preferredAppointmentTimeslot: PropTypes.string,
    workItemAgreement: PropTypes.string,
    transitions: PropTypes.arrayOf(
      PropTypes.shape({ transitions: PropTypes.string })
    ),
    name: PropTypes.string,
    reference: PropTypes.string,
    wiCategory: PropTypes.string,
    jobSpecificAccessNotes: PropTypes.string,
    createdOn: PropTypes.string,
    id: PropTypes.string,
    workItemNotes: PropTypes.string,
    workitemtemplatedisplayname: PropTypes.string,
  }).isRequired,
};

export default WorkOrderActiveWorkItem;
